import { cn } from "@babybjorn/ui";
import type { FC } from "react";
import Icon from "../../../components/general/Icon/Icon";
import * as s from "./Counter.module.scss";

type CounterProps = {
	count: number;
	increment: () => Promise<void> | void;
	decrement: () => Promise<void> | void;
	incrementLabel: string;
	decrementLabel: string;
};

const Counter: FC<CounterProps> = ({
	count,
	increment,
	decrement,
	incrementLabel,
	decrementLabel,
}) => (
	<div className={cn(s.counterContainer)}>
		<button
			className={cn(s.counterButton)}
			onClick={() => void decrement()}
			aria-label={decrementLabel}
		>
			<Icon icon="minus" />
		</button>
		<span className={cn(s.counterNumber)}>{count}</span>
		<button
			className={cn(s.counterButton)}
			onClick={() => void increment()}
			aria-label={incrementLabel}
		>
			<Icon icon="plus" />
		</button>
	</div>
);

export default Counter;
